import React, { Component, Fragment } from 'react'

import moment from 'moment'
import {
  DatePicker,
  Layout,
  Breadcrumb,
  Form,
  Input,
  Divider,
  Row,
  Col,
  Avatar,
  Select,
  Switch,
  Tag,
  Icon,
  Spin,
  Checkbox,
  message,
  notification,
  Skeleton,
  Popover,
  Radio,
  Tabs,
  InputNumber,
  List,
  Card,
} from 'antd'
import _ from 'lodash'
import $ from 'jquery'
import {
  SearchOutlined,
  CopyOutlined,
  FormOutlined,
  ShopOutlined,
} from '@ant-design/icons'
// import styles from './styles.module.scss';
import AppHelper from 'libs/AppHelper'
import { API_HOST } from '../../configs/env'
import whttp from '../../libs/whttp'
import Errors from 'validatorjs/src/errors'
import ValidatorErrorAlert from '../../components/ValidatorErrorAlert/ValidatorErrorAlert'
import CitySelect from 'components/CitySelect/CitySelect'
import { genFormItemAtrribute } from 'libs/FormHelper'
import { RadioControl, CheckboxControl } from '@wordpress/components'
import { withState } from '@wordpress/compose'
import bannerImage from 'assets/img/banner/banner-catalog.png'
import { store } from '../../reducers'
import { updateAuthInfo } from '../../reducers/auth'
import { UploadOutlined } from '@ant-design/icons'
import WUpload from 'components/WUpload/WUpload'
import { __ } from '@wordpress/i18n'
import JsBarcode from 'jsbarcode'

const Local = _.get(window, 'VC_CONFIG.Locale')
const defaultListInfo = {
  current: 1, //目前頁數
  page_size: 10, //一頁幾筆
  total: 1, //以此query條件，總共幾筆資料
  rows: [],
}
const Option = Select.Option
const { TabPane } = Tabs
// 前端頁面
export default class UserProfile extends Component {
  formRef = React.createRef()
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
    isSubmitData: false,
    isLoading: false,
  }
  componentDidMount() {
    AppHelper.updateConfig()

    this.setState({
      isFetchData: true,
      isLoading: true,
      info: this.props.user,
    })

    AppHelper.updateUserInfo(() => {
      this.setState({ isFetchData: false, isLoading: false }, () => {
        this.reloadTab()
      })

      this.fillData(this.props.user)
    })
    // 登入換 tokne
    //http://cec.syscom.tw:8880/api/account/getAccessToken?code=4854c9565059992e98a33fbcde41597f
    // 電子發票列表
    // http://{{hostip}}//api/account/eInvoiceList
    // 點數紀錄 / 消費記錄
    // 密碼變更
    // 查詢編輯會員資料
    // 查詢好康卡會員資料
  }
  reloadTab = () => {
    // tab 共用動態
    var $el, leftPos, newWidth
    /* Add Magic Line markup via JavaScript, because it ain't gonna work without */
    let $magicLine = $('#magic-line')

    if (!_.get($magicLine, 0)) {
      console.log('kkk c', $magicLine)
      $('.basic-tabs-label ul').append("<li id='magic-line'></li>")
    }
    /* Cache it */
    $magicLine = $('#magic-line')

    $magicLine
      .width($('.current_page_item').width())
      .css('left', $('.current_page_item a').position().left)
      .data('origLeft', $magicLine.position().left)
      .data('origWidth', $magicLine.width())

    $('.basic-tabs-label ul li a').unbind('mouseenter mouseleave')
    $('.basic-tabs-label ul li')
      .find('a')
      .hover(
        function() {
          $el = $(this)
          console.log('basic-tabs-label', $el)
          leftPos = $el.position().left
          newWidth = $el.parent().width()

          $magicLine.stop().animate({
            left: leftPos,
            width: newWidth,
          })
        },
        function() {
          $magicLine.stop().animate({
            left: $magicLine.data('origLeft'),
            width: $magicLine.data('origWidth'),
          })
        }
      )

    $('#pills-tab .nav-item').unbind('mouseenter mouseleave')
    $('#pills-tab .nav-item')
      .mouseenter(function() {
        if (!$(this).hasClass('highlight')) {
          $('.highlight').removeClass('current_page_item')
        }
      })
      .mouseleave(function() {
        $('.highlight').addClass('current_page_item')
      })
  }
  fillData = (data) => {
    if (!this.formRef.current) return

    // 處理資料，本地適合Form Control的資料
    if (!_.isNil(data.addresses) || !_.isArray(data.addresses)) {
      data.address = {
        city_id: _.get(data.addresses[0], 'city_id'),
        area_id: _.get(data.addresses[0], 'area_id'),
      }
      data.street = _.get(data.addresses[0], 'street')
    }
    if (data.birthday) {
      data.birthday = moment(data.birthday)
    }

    console.log('filldata', data)
    this.formRef.current.setFieldsValue(data)
  }

  submitData = (info = {}) => {
    info.addresses = [
      {
        city_id: _.get(info, 'address.city_id'),
        area_id: _.get(info, 'address.area_id'),
        street: _.get(info, 'street'),
      },
    ]
    console.log(info)
    info.birthday = moment(_.get(info, 'birthday')).format('YYYY-MM-DD')
    info.flag = _.get(info, 'flag') ? 1 : 0
    info.agree_receive_sms = _.get(info, 'agree_receive_sms') ? 1 : 0
    info.sync_to_cls = _.get(info, 'sync_to_cls') ? 1 : 0
    delete info['address']
    console.log('info', info)
    this.setState({ isSubmitData: true, messages: {} })

    whttp.post(API_HOST + `/api/account/updProfile`, info, (state, res) => {
      console.log(state, res, info)
      this.setState({ isSubmitData: false })

      const { code = 100, reason = '發生錯誤', data = {} } = res

      if (state === false) {
        return message.error('發生錯誤')
      }

      if (code !== 200) {
        notification['error']({
          message: '更新失敗',
          description: reason,
        })

        return this.setState({ messages: data.messages || {} })
      }

      notification['success']({
        message: '修改成功',
      })
      window.location.href = window.VC_CONFIG.INDEX_URL + '/profile'
    })
  }

  render() {
    const errors = _.get(this, 'state.validator.errors', new Errors())
    const options = _.get(this, 'props.app.options', {})
    const { info } = this.state
    return (
      <div>
        <main className='bg-light'>
          <div className='container'>
            <section className='pt-2 pb-2'>
              <div className='breadcrumb-wrap'>
                <nav aria-label='breadcrumb'>
                  {Local == 'zh_TW' && (
                    <ol className='breadcrumb'>
                      <li className='breadcrumb-item'>
                        <a href={`${window.VC_CONFIG.INDEX_URL}/`}>
                          {__('首頁', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li className='breadcrumb-item'>
                        <a href={`${window.VC_CONFIG.INDEX_URL}/profile`}>
                          {__('會員中心', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li
                        className='breadcrumb-item active'
                        aria-current='page'>
                        {__('網站帳號', 'cec-plugin-stores')}
                      </li>
                    </ol>
                  )}
                  {Local == 'en_US' && (
                    <ol className='breadcrumb'>
                      <li className='breadcrumb-item'>
                        <a href={`${window.VC_CONFIG.INDEX_URL}/en`}>
                          {__('首頁', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li className='breadcrumb-item'>
                        <a
                          href={`${window.VC_CONFIG.INDEX_URL}/profile-en`}>
                          {__('會員中心', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li
                        className='breadcrumb-item active'
                        aria-current='page'>
                        {__('網站帳號', 'cec-plugin-stores')}
                      </li>
                    </ol>
                  )}
                </nav>
              </div>
              <h6 className='h5 lh-h4 mb-5 text-navy text-lg-left text-center'>
                {__('親愛的', 'cec-plugin-stores')}{' '}
                <b className='fw-700'>{info && info.cn_name}</b>
                <br className='d-block d-lg-none' />
                {__('您好，歡迎來到會員中心！', 'cec-plugin-stores')}
              </h6>
            </section>
          </div>
          <section className='pt-0'>
            <div className='mb-5 basic-tabs-label'>
              {Local == 'zh_TW' && (
                <ul className='nav nav-pills' id='pills-tab'>
                  <li className='nav-item current_page_item highlight'>
                    <a
                      className='nav-link'
                      href={`${window.VC_CONFIG.INDEX_URL}/profile`}>
                      {__('網站帳號', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {info && info.spcode === 'C4' && (
                    <li className='nav-item'>
                      <a
                        className='nav-link'
                        href={`${window.VC_CONFIG.INDEX_URL}/pwd`}>
                        {__('更改密碼', 'cec-plugin-stores')}
                      </a>
                    </li>
                  )}
                  <li className='nav-item'>
                    <a
                      className='nav-link '
                      href={`${window.VC_CONFIG.INDEX_URL}/loyaltyprofile`}>
                      {__('好康卡會員資料', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {/* <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${window.VC_CONFIG.INDEX_URL}/payment`}
                    >
                      {__('我的消費紀錄', 'cec-plugin-stores')}
                    </a>
                  </li> */}
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${window.VC_CONFIG.INDEX_URL}/point`}>
                      {__('點數紀錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${window.VC_CONFIG.INDEX_URL}/invoice`}>
                      {__('電子發票記錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${window.VC_CONFIG.INDEX_URL}/connect`}>
                      {__('第三方登入設定', 'cec-plugin-stores')}
                    </a>
                  </li>
                </ul>
              )}
              {Local == 'en_US' && (
                <ul className='nav nav-pills' id='pills-tab'>
                  <li className='nav-item current_page_item highlight'>
                    <a
                      className='nav-link'
                      href={`${window.VC_CONFIG.INDEX_URL}/profile-en`}>
                      {__('網站帳號', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {info && info.spcode === 'C4' && (
                    <li className='nav-item'>
                      <a
                        className='nav-link'
                        href={`${window.VC_CONFIG.INDEX_URL}/pwd-en`}>
                        {__('更改密碼', 'cec-plugin-stores')}
                      </a>
                    </li>
                  )}
                  <li className='nav-item'>
                    <a
                      className='nav-link '
                      href={`${
                        window.VC_CONFIG.INDEX_URL
                      }/loyaltyprofile-en`}>
                      {__('好康卡會員資料', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {/* <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${window.VC_CONFIG.INDEX_URL}/payment-en`}>
                      {__('我的消費紀錄', 'cec-plugin-stores')}
                    </a>
                  </li> */}
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${window.VC_CONFIG.INDEX_URL}/point-en`}>
                      {__('點數紀錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${window.VC_CONFIG.INDEX_URL}/invoice-en`}>
                      {__('電子發票記錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${window.VC_CONFIG.INDEX_URL}/connect-en`}>
                      {__('第三方登入設定', 'cec-plugin-stores')}
                    </a>
                  </li>
                </ul>
              )}
            </div>
            <div className='container'>
              <div class='card border-0 shadow-0 mb-4'>
                <div class='card-body p-5'>
                  <div class='row no-gutters mx-n3'>
                    <div class='col-md-6 mx-auto'>
                      <p className='h6 text-navy mb-4'>
                        {__('我的帳號', 'cec-plugin-stores')}：
                        {info && info.email}
                      </p>
                      <p className='h6 text-navy mb-4'>
                        {__('連結好康卡', 'cec-plugin-stores')}：
                        {info &&
                          info.cardInfo &&
                          info.cardInfo.cardnumber && (
                            <svg
                              class='barcode img-fluid mb-5'
                              jsbarcode-value={info.cardInfo.cardnumber}
                              jsbarcode-width='4'
                              jsbarcode-height='50'
                            />
                          )}
                      </p>
                      <p className='note text-success mb-0'>
                        {__(
                          '一個網站帳號僅能連結一張好康卡(或聯名卡)， 無論您選擇哪一張卡片進行連結，所有卡片消費時皆可累積點數，會員資料、紅利點數皆為同一會員帳戶所有。',
                          'cec-plugin-stores',
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <Form
                noStyle
                ref={this.formRef}
                name='basic'
                layout='vertical'
                onFinish={(values) => this.submitData(values)}
                onValuesChange={(changedFields, allFields) => {
                  console.log('onValuesChange:', changedFields, allFields)
                }}
                // onFinishFailed={errorInfo => console.log('onFinishFailed:', errorInfo)}
                // onFieldsChange={(changedFields, allFields) => {
                //     const storeInfo = _.reduce(allFields,(obj,item) => {
                //         _.set(obj, item.name.join('.'), item.value)
                //         return obj
                //       }, {})
                //       console.log('onFieldsChange:', storeInfo, changedFields, allFields)
                //       return true
                //     }}
              >
                <div className='row no-gutters mx-n3 mb-4'>
                  <div className='col-lg-3 px-3'>
                    <div className='card border-0 shadow-0 h-100'>
                      <div className='card-body pb-0 pt-5 p-lg-5'>
                        <h5 className='h4 text-navy text-center'>
                          {__('帳號資料', 'cec-plugin-stores')}
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div className='col-lg-9 px-3'>
                    <Spin spinning={this.state.isSubmitData}>
                      <Skeleton loading={this.state.isFetchData}>
                        <div className='card border-0 shadow-0 h-100'>
                          <div className='card-body p-5'>
                            {info && info.spcode === 'C4' && (
                              <div className='form-group mb-4 row align-items-center'>
                                <label
                                  className='col-sm-2 col-form-label h6 text-navy'
                                  for=''>
                                  {__('帳號', 'cec-plugin-stores')}*
                                </label>
                                <div className='col-sm-10'>
                                  <input
                                    className='form-control'
                                    type='text'
                                    disabled='disabled'
                                    readonly=''
                                    value={info && info.email}
                                    id=''
                                  />
                                </div>
                              </div>
                            )}
                            <div className='form-group mb-4 row align-items-center'>
                              <label
                                className='col-sm-2 col-form-label h6 text-navy'
                                for=''>
                                {__('中文姓名', 'cec-plugin-stores')}*
                              </label>
                              <div className='col-sm-10'>
                                <Form.Item
                                  rules={[
                                    {
                                      required: true,
                                      message: __(
                                        '請輸入中文姓名',
                                        'cec-plugin-stores',
                                      ),
                                    },
                                  ]}
                                  {...genFormItemAtrribute('cn_name')}>
                                  <Input className='form-control' />
                                </Form.Item>
                              </div>
                            </div>
                            <div className='form-group mb-4 row align-items-center'>
                              <label
                                className='col-sm-2 col-form-label h6 text-navy'
                                for=''>
                                {__('英文姓名', 'cec-plugin-stores')}*
                              </label>
                              <div className='col-sm-10'>
                                <Form.Item
                                  rules={[
                                    {
                                      required: true,
                                      message: __(
                                        '請輸入英文姓名',
                                        'cec-plugin-stores',
                                      ),
                                    },
                                  ]}
                                  {...genFormItemAtrribute('en_name')}>
                                  <Input className='form-control' />
                                </Form.Item>
                              </div>
                            </div>
                            <div className='form-group mb-4 row align-items-center'>
                              <label
                                className='col-sm-2 col-form-label h6 text-navy'
                                for=''>
                                {__('生日', 'cec-plugin-stores')}*
                              </label>
                              <div className='col-sm-10'>
                                <Form.Item
                                  rules={[
                                    {
                                      required: true,
                                      message: __(
                                        '請選擇生日',
                                        'cec-plugin-stores',
                                      ),
                                    },
                                  ]}
                                  {...genFormItemAtrribute(
                                    'birthday',
                                    null,
                                  )}>
                                  <DatePicker
                                    placeholder='請選擇生日'
                                    className='form-control'
                                    format='YYYY-MM-DD'
                                  />
                                </Form.Item>
                              </div>
                            </div>
                            <div className='form-group mb-4 row align-items-center'>
                              <label
                                className='col-sm-2 col-form-label h6 text-navy'
                                for=''>
                                {__('地址', 'cec-plugin-stores')}*
                              </label>
                              <div className='col-sm-10'>
                                <Form.Item label=''>
                                  <Input.Group compact>
                                    <Form.Item
                                      name='address'
                                      noStyle
                                      className='form-control'
                                      rules={[
                                        {
                                          required: true,
                                          message: __(
                                            '請選擇縣市區域',
                                            'cec-plugin-stores',
                                          ),
                                        },
                                      ]}>
                                      <CitySelect
                                        placeholder='請選擇縣市'
                                        style={{ width: '30%' }}
                                      />
                                    </Form.Item>
                                    <Form.Item
                                      name='street'
                                      noStyle
                                      className='form-control'
                                      rules={[
                                        {
                                          required: true,
                                          message: __(
                                            '請輸入地址',
                                            'cec-plugin-stores',
                                          ),
                                        },
                                      ]}>
                                      <Input
                                        style={{ width: '70%' }}
                                        placeholder='輸入地址'
                                      />
                                    </Form.Item>
                                  </Input.Group>
                                </Form.Item>
                              </div>
                            </div>
                            <div className='form-group mb-4 row align-items-center'>
                              <label
                                className='col-sm-2 col-form-label h6 text-navy'
                                for=''>
                                {__('手機', 'cec-plugin-stores')}*
                              </label>
                              <div className='col-sm-10'>
                                <Form.Item
                                  rules={[
                                    {
                                      required: true,
                                      pattern: new RegExp('^[0-9]{10}$'),
                                      message: __(
                                        '請輸入正確手機號碼',
                                        'cec-plugin-stores',
                                      ),
                                    },
                                  ]}
                                  {...genFormItemAtrribute('mobile')}>
                                  <Input className='form-control' />
                                </Form.Item>
                              </div>
                            </div>
                            <div className='form-group mb-4 row align-items-center'>
                              <label
                                className='col-sm-2 col-form-label h6 text-navy'
                                for=''>
                                {__('居住電話', 'cec-plugin-stores')}
                              </label>
                              <div className='col-sm-10'>
                                <Form.Item
                                  {...genFormItemAtrribute('home_phone')}>
                                  <Input className='form-control' />
                                </Form.Item>
                              </div>
                            </div>
                            <div className='form-group mb-4 row align-items-center'>
                              <label
                                className='col-sm-2 col-form-label h6 text-navy'
                                for=''>
                                {__('公司電話', 'cec-plugin-stores')}
                              </label>
                              <div className='col-sm-10'>
                                <Form.Item
                                  {...genFormItemAtrribute('work_phone')}>
                                  <Input className='form-control' />
                                </Form.Item>
                              </div>
                            </div>
                            <div className='form-group mb-4 row align-items-center'>
                              <label
                                className='col-sm-2 col-form-label h6 text-navy'
                                for=''>
                                {__('電子信箱', 'cec-plugin-stores')}*
                              </label>
                              <div className='col-sm-10'>
                                <Form.Item
                                  rules={[
                                    {
                                      required: true,
                                      message: __(
                                        '請輸入信箱',
                                        'cec-plugin-stores',
                                      ),
                                    },
                                  ]}
                                  {...genFormItemAtrribute('email')}>
                                  <Input className='form-control' />
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Skeleton>
                    </Spin>
                  </div>
                </div>
                <div className='row no-gutters mx-n3 mb-4'>
                  <div className='col-lg-3 px-3'>
                    <div className='card border-0 shadow-0 h-100'>
                      <div className='card-body pb-0 pt-5 p-lg-5'>
                        <h5 className='h4 text-navy text-center'>
                          {__('訂閱相關活動訊息', 'cec-plugin-stores')}
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div className='col-lg-9 px-3'>
                    <Spin spinning={this.state.isSubmitData}>
                      <Skeleton loading={this.state.isFetchData}>
                        <div className='card border-0 shadow-0 h-100'>
                          <div className='card-body p-5'>
                            <div className='form-group mb-4 row align-items-center'>
                              <div className='col-sm-10'>
                                <Form.Item
                                  {...genFormItemAtrribute(
                                    'flag',
                                    null,
                                    'checked',
                                  )}>
                                  <Checkbox value={true}>
                                    {__(
                                      '我授權給使用我的資料，將網路促銷活動、店內促銷活動、會員最新消息、遊戲及及其他公司集團品牌新聞，發送至我的信箱。',
                                      'cec-plugin-stores',
                                    )}
                                  </Checkbox>
                                </Form.Item>
                              </div>
                            </div>
                            <div className='form-group mb-4 row align-items-center'>
                              <div className='col-sm-10'>
                                <Form.Item
                                  {...genFormItemAtrribute(
                                    'agree_receive_sms',
                                    null,
                                    'checked',
                                  )}>
                                  <Checkbox value={true}>
                                    {__(
                                      '我想要收到寄給我的手機簡訊 (※以上功能僅針對官網會員，好康卡會員若要取消簡訊寄送服務，請撥打客服專線：0809-001-365，客服人員會代為協助處理，謝謝！)',
                                      'cec-plugin-stores',
                                    )}
                                  </Checkbox>
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Skeleton>
                    </Spin>
                  </div>
                </div>
                <div className='row no-gutters mx-n3 mb-4'>
                  <div className='col-lg-3 px-3'>
                    <div className='card border-0 shadow-0 h-100'>
                      <div className='card-body pb-0 pt-5 p-lg-5'>
                        <h5 className='h4 text-navy text-center'>
                          {__('資料同步', 'cec-plugin-stores')}
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div className='col-lg-9 px-3'>
                    <Spin spinning={this.state.isSubmitData}>
                      <Skeleton loading={this.state.isFetchData}>
                        <div className='card border-0 shadow-0 h-100'>
                          <div className='card-body p-5'>
                            <div className='col-sm-10'>
                              <Form.Item
                                {...genFormItemAtrribute(
                                  'sync_to_cls',
                                  null,
                                  'checked',
                                )}>
                                <Checkbox value={true}>
                                  {__(
                                    '同步網站會員資料至好康卡會員資料',
                                    'cec-plugin-stores',
                                  )}
                                </Checkbox>
                              </Form.Item>
                            </div>
                            <p className=' text-dark fw-300'>
                              {__(
                                '※若您勾選此項目，系統將自動同步網站會員資料至好康卡會員資料，但姓名及生日無法同步修改，如您發現姓名或生日與您申請資料不符，請與客服中心聯絡作資料的修改，以確保會員資料的正確性。',
                                'cec-plugin-stores',
                              )}
                            </p>
                            <p className=' text-dark fw-300'>
                              {__(
                                '※由於促銷目錄為提前印製，故於網站更新個人地址後，目錄寄件資料更新約需30個工作天，造成您不便之處盼您見諒！！',
                                'cec-plugin-stores',
                              )}
                            </p>
                          </div>
                        </div>
                      </Skeleton>
                    </Spin>
                  </div>
                </div>
              </Form>
              <div className='row no-gutters mx-n3 mb-4'>
                <div className='col-lg-3 px-3'>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body d-flex justify-content-center align-items-center pb-0 pt-5 p-lg-5'>
                      <h5 className='h4 text-navy text-center'>
                        {__('注意事項', 'cec-plugin-stores')}
                      </h5>
                    </div>
                  </div>
                </div>
                <div className='col-lg-9 px-3'>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body p-5'>
                      <p className='h6 text-navy text-justify'>
                        {__(
                          '若您同時擁有好康卡及聯名卡，兩張卡片可擇一輸入。無論選擇哪一張卡片，所有卡片消費時皆可累積點數，會員資料、紅利點數皆為同一個帳戶所有。一個網站帳號僅能連結一個好康卡(或聯名卡)。',
                          'cec-plugin-stores',
                        )}
                      </p>
                      <p className='h6 text-navy text-justify'>
                        {__(
                          '※ 身份證字號英文字母需大寫，若是您沒有身分證字號，請輸入您的居留證號碼或是護照號碼進行綁定。 ',
                          'cec-plugin-stores',
                        )}
                      </p>
                      <p className='h6 text-navy text-justify'>
                        {__(
                          '※ 請輸入完整好康卡或聯名卡號，請勿有空格或符號。 好康卡範例：1465121897610145 ；聯名卡範例：5252558843433636',
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='text-center mt-5'>
                <a
                  className='h6 btn btn-outline-primary rounded-pill px-5 py-4'
                  role='button'
                  href='#'
                  onClick={(e) => {
                    e.preventDefault()
                    this.formRef.current.submit()
                  }}>
                  {__('確定修改', 'cec-plugin-stores')}
                </a>
              </div>
            </div>
          </section>
        </main>
      </div>
    )
  }
}

// 編輯器
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 }
export class UserProfileEditor extends Component {
  formRef = React.createRef()
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
  }
  componentDidMount() {
    AppHelper.updateConfig()
    console.log('kkk', this.props.attributes)

    this.formRef.current.setFieldsValue(this.props.attributes)
  }
  render() {
    const listInfo = this.state.listInfo
    const options = _.get(this, 'props.app.options', {})
    console.log('editor', this.props)

    return (
      <div className='wp-block-cec-vulcan-block-catalogue-list-editor'>
        <h2>會員資訊模組</h2>
        <Form ref={this.formRef} name='basic' className='basicForm' />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/blocks/users/user-profile.js